import { useCallback, useState } from 'react';

export interface DialogController {
  open: boolean;
  data?: any;
  handleClose: () => void;
  handleOpen: (data?: any) => void;
}

export const useDialog = () : DialogController => {
  const [state, setState] = useState<{open: boolean, data?: any}>({
    open: false
  });

  const handleOpen = useCallback((data?: any): void => {
    setState({open: true, data});
  },[]);

  const handleClose = useCallback((): void => {
    setState({open: false});
  }, []);

  return {
    open: state.open,
    data: state.data,
    handleClose,
    handleOpen
  };
};
